import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './About.css';

export const About: React.FC = () => {
  useEffect(() => { document.title = 'About | Practical Media'; }, []);
  return (
    <div className="about-page">
      <header className="container about-hero">
        <p className="about-eyebrow">About</p>
        <h1 className="about-title">
          Two solo devs who got into <span className="about-hl">publishing.</span>
        </h1>
        <p className="about-lead">
          Practical Media is an indie game publisher started by the founder
          of <a href="https://solodevelopment.org" target="_blank" rel="noopener noreferrer">SoloDevelopment</a>.
        </p>
      </header>

      <section className="container about-block">
        <p className="label">The deal</p>
        <ul className="about-deal">
          {[
            'You keep 100% IP ownership',
            'Performance-based revenue split',
            'Real-time dashboard access to all metrics',
            'Post-launch support included',
          ].map((item) => (
            <li key={item} className="about-deal-item">
              <svg className="about-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
              </svg>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="container about-block">
        <p className="label">Team</p>
        <div className="team about-team">
          <div className="team-member">
            <p className="team-name">PracticalNPC</p>
            <p className="team-tags">Solo Developer / Godot</p>
            <p className="body-text">Made <a href="https://store.steampowered.com/app/1712700/Memori/" target="_blank" rel="noopener noreferrer nofollow">Memori</a>. Founded <a href="https://solodevelopment.org" target="_blank" rel="noopener noreferrer">SoloDevelopment</a>.</p>
          </div>
          <div className="team-member">
            <p className="team-name">Tomer</p>
            <p className="team-tags">Solo Developer / Custom Engine</p>
            <p className="body-text">Built the site and infrastructure.</p>
          </div>
        </div>
      </section>

      <section className="container about-block">
        <div className="about-cta">
          <div className="about-cta-row">
            <Link to="/contact" className="primary-btn">
              <svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M7 5v14l12-7z" fill="currentColor" /></svg>
              Pitch your game
            </Link>
            <a href="https://discord.com/invite/U7dYpq5yMK" target="_blank" rel="noopener noreferrer nofollow" className="btn-ghost">Chat on Discord</a>
          </div>
        </div>
      </section>
    </div>
  );
};
